/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const payment = {
  paymentForm: {
    payment: 'Pago',
    choosePagoMethod: 'Elige un método de pago',
    paymentType: 'Tipo de Pago',
    accountHolderName: {
      label: 'Nombre del titular de la cuenta',
      placeholder: 'Nombre del titular de la cuenta',
    },
    cardNumber: 'Número de tarjeta',
    expirationDate: 'Fecha de caducidad',
    securityCode: 'Código de seguridad (CVV)',
    securityCodeTitle: 'Valor de verificación de la tarjeta',
    saveAsDefault: 'Guardar como predeterminado',
    setAsDefault: 'Establecer como método de pago predeterminado',
    billingAddress: 'Dirección de facturación',
    sameAsDeliveryAddress: 'Igual que la dirección de entrega',
    billingAddressSameAsShipping:
      'La dirección de facturación es la misma que la dirección de entrega',
    selectOne: 'Seleccione una...',
    monthMask: 'MILÍMETRO',
    yearMask: 'AAAAA',
    expirationYear: 'Año de caducidad {{ selected }}',
    expirationMonth: 'Mes de caducidad {{ selected }}',
    useThisPago: 'Usa este pago',
    addNewPago: 'Agregar nuevo Pago',
    paymentAddedSuccessfully: 'El nuevo pago se agregó correctamente',
    changePago: 'Cambiar Pago',
  },
  paymentMethods: {
    paymentMethods: 'Métodos de pago',
    paymentMethodSeleccionado: 'Método de pago seleccionado',
    newPaymentMethodsAreAddedDuringCheckout:
      'Los nuevos métodos de pago se agregan durante el proceso de pago.',
    invalidField: 'InvalidField: {{ field }}',
  },
  paymentCard: {
    deleteConfirmation: 'Are you sure you want to delete this payment method?',
    setAsDefault: 'Establecer como predeterminado',
    expires: 'Expires: {{ month }}/{{ year }}',
    defaultPagoMethod: '✓ POR DEFECTO',
    defaultPagoLabel: 'Método de pago predeterminado',
    additionalPagoLabel: 'Forma de pago adicional {{ number }}',
    selected: 'Seleccionado',
    deletePagoSuccess: 'El método Pago se eliminó con éxito',
  },
  paymentTypes: {
    title: 'Método Pago',
    paymentType_CARD: 'Tarjeta de crédito',
    paymentType_ACCOUNT: 'Cuenta',
  },
  paymentMessages: {
    setAsDefaultSuccessfully: 'El nuevo pago se estableció correctamente como predeterminado',
  },
};
